'use strict';

angular.module('cdPay.routes', ['cdPay.routes.home', 'cdPay.routes.notFound']);
